import { buildPath, CommonPaths } from './commonPaths';
import { EventParams, EventsPaths } from './eventsPaths';
import { WorkflowIdPathParam } from './pathsTypes';

const slugs = {
    ITEMS: {
        WORKFLOWS: {
            PLURAL: 'workflows',
            SINGLE: 'workflow'
        }
    }
};

const itemsPaths = {
    WORKFLOW(id: WorkflowIdPathParam) {
        return buildPath([slugs.ITEMS.WORKFLOWS.SINGLE, id]);
    }
};

type WorkflowsParams = EventParams & {
    workflowId: WorkflowIdPathParam;
};

export const WorkflowsPaths = {
    // read
    WORKFLOWS(eventParams: EventParams) {
        return buildPath([EventsPaths.EVENT(eventParams), slugs.ITEMS.WORKFLOWS.PLURAL]);
    },
    WORKFLOW({ workflowId, ...params }: WorkflowsParams) {
        return buildPath([EventsPaths.EVENT(params), itemsPaths.WORKFLOW(workflowId)]);
    },

    // create
    CREATE(eventParams: EventParams) {
        return CommonPaths.CREATE(WorkflowsPaths.WORKFLOWS(eventParams));
    },

    // update
    UPDATE(workflowParams: WorkflowsParams) {
        return CommonPaths.EDIT(WorkflowsPaths.WORKFLOW(workflowParams));
    }
};
